import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const MainBoxEmployee = styled.div`
  padding: ${rem('30px')} ${rem('16px')};
  position: relative;

  &:after {
    content: '';
    clear: both;
    display: block;
    height: 0;
    font-size: 0;
  }

  ${mediaqueries.greaterThan('tablet')`
    padding: ${rem('30px')};
  `};
`;

const TitleBoxEmployee = styled.h3`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('15px')};
  margin: 0 0 ${rem('10px')} 0;
  padding: 0;
  text-transform: uppercase;
  ${mediaqueries.greaterThan('tablet')`
    margin: 0 0 ${rem('16px')} 0;
  `};
`;

const EditIcon = styled(Icon)`
  ${mediaqueries.greaterThan('mobile')`
    margin: ${rem('13px')} ${rem('13px')} 0 0;
    position: absolute;
    right: 0;
    top: 0;
  `};
`;

const WrapperButton = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    text-align: right;
  `};
`;

export { MainBoxEmployee, TitleBoxEmployee, EditIcon, WrapperButton };
